
/*!
 * 侧边栏菜单
 */
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import cssStyle from '@/assets/styles/_variables.scss'

@Component
export default class SidebarMenu extends AbpBase {
  name: string = 'SidebarMenu'

  @Prop({ type: Array }) menuList: Array<any>
  @Prop() collapse: boolean

  openSubMenus: Array<string> = []

  get cssStyle() {
    return cssStyle
  }

  /**
   * 获得菜单标题
   */
  itemTitle(item: any): string {
    return this.L(item.meta.title)
  }

  /**
   * 数组深度递归查找
   * @param {Array} arr 要搜索的数组
   * @param {Function} condition 回调函数，必须返回boolean，判断是否找到了。会传入(item, index, level)三个参数
   * @param {String} children 子数组的key
   */
  deepFind = (arr, condition, children) => {
    let result = []
    try {
      ;(function poll(arr, level) {
        if (!Array.isArray(arr)) return

        for (let i = 0; i < arr.length; i++) {
          const item = arr[i]
          result[level] = item
          const isFind = (condition && condition(item, i, level)) || false
          if (isFind) {
            throw Error
          } else if (children && item[children] && item[children].length) {
            poll(item[children], level + 1)
          } else if (i === arr.length - 1) {
            result.length = result.length - 1
          }
        }
      })(arr, 0)
    } catch (err) {}
    return result
  }

  get activeMenuName() {
    return this.$store.state.app.activeMenuName
  }

  @Emit('on-change')
  onSelectMenu(name: string) {
    if (this.activeMenuName === name) {
      return ''
    }
    this.$store.commit('app/setActiveMenuName', name)
    return name
  }

  updated() {
    if (!!this.activeMenuName) {
      return
    }
    // 设置选中高亮的菜单项
    this.$nextTick(() => {
      let currentName = this.$store.state.app.currentPageName

      let res = this.deepFind(
        this.menuList,
        (item, idx, level) => item.name === currentName,
        'children'
      )
      if (!res || !res.length) {
        return
      }
      this.$store.commit('app/setActiveMenuName', res[res.length - 1].name)
    })
  }
}
